import React, { forwardRef, useRef, useMemo, useState } from 'react'
import { THREE } from 'expo-three';
import { useBox } from '../../systems/Physics/hooks'
import useCollision from '../../hooks/useCollision'
import anime from '../../helpers/anime';

export default forwardRef(({
  hx = 0.5,
  hy = 3,
  rotate = 0,
  color = '#34383a',
  ...props
}, ref) => {
  let api
  let baseRef = ref || useRef();
  [baseRef, api] = useBox({}, ref)
  const [material] = useState(new THREE.MeshLambertMaterial({ color, transparent: true, opacity: 1, wireframe: false }))

  useCollision(() => {
    api.destroy(baseRef.current?.uuid)
    anime({
      easing: 'linear',
      duration: 500,
      opacity: 0,
      targets: material,
      complete: () => {
        baseRef.current.visible = false
      },
    })
  }
  , baseRef.current?.uuid)

  return useMemo(() => {
    return (
      <>
        <mesh
          ref={baseRef}
          rotation={[-Math.PI / 2, 0, rotate]}
          {...props}
          userData={{
            origin: props.position,
            static: true,
            hx: hx/2,
            hy: hy/2,
            rotate: false,
            angle: rotate,
            isWall: true,
          }}
          material={material}
          castShadow
        >
          <boxBufferGeometry args={[hx, hy, hy/2, 10]} />
          {/* <meshStandardMaterial color={'orange'} /> */}
        </mesh>
      </>
    )
  }
  , [])
})